import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const Home: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="home-container">
      <section className="hero">
        <h1>Welcome to Stinkless.org</h1>
        <p>Your serverless web application for [description of purpose]</p>
        
        {!isAuthenticated && (
          <div className="cta-buttons">
            <Link to="/sign-up" className="btn btn-primary">Get Started</Link>
            <Link to="/sign-in" className="btn btn-secondary">Sign In</Link>
          </div>
        )}
        
        {isAuthenticated && (
          <div className="cta-buttons">
            <Link to="/dashboard" className="btn btn-primary">Go to Dashboard</Link>
          </div>
        )}
      </section>
      
      <section className="features">
        <h2>Key Features</h2>
        <div className="feature-grid">
          <div className="feature-card">
            <h3>Feature 1</h3>
            <p>Description of feature 1</p>
          </div>
          <div className="feature-card">
            <h3>Feature 2</h3>
            <p>Description of feature 2</p>
          </div>
          <div className="feature-card">
            <h3>Feature 3</h3>
            <p>Description of feature 3</p>
          </div>
        </div>
      </section>
      
      <section className="about">
        <h2>About Stinkless.org</h2>
        <p>
          This is a serverless web application built with React, AWS Amplify, 
          and a variety of AWS services including Cognito for authentication,
          S3 for storage, API Gateway and Lambda for the backend, and DynamoDB 
          for the database.
        </p>
      </section>
    </div>
  );
};

export default Home;